// mutations
const RESTAURANT_DELIVERIES_ALL = (state, deliveries) => {
  if (deliveries.code === 1) {
    state.deliveries = deliveries.data
    state.status = 'success'
  } else {
    alert(deliveries.message)
    state.status = 'error'
  }
}

const RESTAURANT_DELIVERIES_FORM = (state, deliveries) => {
  if (deliveries.code === 1) {
    state.deliveries = deliveries.data
    state.status = 'success'
  } else {
    alert(deliveries.message)
    state.status = 'error'
  }
}

const RESTAURANT_DELIVERIES_SHOW = (state, deliveries) => {
  if (deliveries.code === 1) {
    state.deliveries = deliveries.data
    state.status = 'success'
  } else {
    alert(deliveries.message)
    state.status = 'error'
  }
}

const RESTAURANT_DELIVERIES_CREATE = (state, deliveries) => {
  if (deliveries.code === 1) {
    state.deliveries = deliveries.data
    state.status = 'success'
  } else {
    alert(deliveries.message)
    state.status = 'error'
  }
}

const RESTAURANT_DELIVERIES_UPDATE = (state, deliveries) => {
  if (deliveries.code === 1) {
    state.deliveries = deliveries.data
    state.status = 'success'
  } else {
    alert(deliveries.message)
    state.status = 'error'
  }
}

const RESTAURANT_DELIVERIES_DELETE = (state, deliveries) => {
  if (deliveries.code === 1) {
    state.deliveries = deliveries.data
    state.status = 'success'
  } else {
    alert(deliveries.message)
    state.status = 'error'
  }
}

export default {
  RESTAURANT_DELIVERIES_ALL,
  RESTAURANT_DELIVERIES_FORM,
  RESTAURANT_DELIVERIES_SHOW,
  RESTAURANT_DELIVERIES_CREATE,
  RESTAURANT_DELIVERIES_UPDATE,
  RESTAURANT_DELIVERIES_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/deliveries/mutations.js